import { FC } from "react";
import { Circle, Icon, Text } from "@chakra-ui/react";

import { CheckMarkIcon } from "../../../../icons";
import { SchedulePaymentStatusType } from "../../../../../api/schedule/types.ts";

interface Props {
  order: number | undefined;
  status: SchedulePaymentStatusType | undefined;
}

export const ScheduleItemCircleStatus: FC<Props> = ({ order, status }) => {
  const orderText = !order && order !== 0 ? "" : (order + 1).toString();
  const textVariant = status === "OVERDUE" ? "white" : "brand";

  const circleColor = () => {
    switch (status) {
      case "PAID": return "green.400";
      case "OVERDUE": return "red.500";
      case "PLANNED": return "gold.500";
      default: return "gray.100";
    }
  };

  return (
    <Circle size="20px" bg={circleColor()}>
      {status === "PAID"
        ? <Icon as={CheckMarkIcon} boxSize="11px" />
        : <Text variant={textVariant} fontSize="10px">{orderText}</Text>}
    </Circle>
  );
};
